import React from "react";
import styles from './AppOptions.module.css'
import { IconButton, InputAdornment, Stack, Switch, TextField, Typography } from "@mui/material";

import { AccessTime } from "@mui/icons-material";
import { NumberField } from "components/forms";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const AppOptions = ({name, packageName, trial, profileOnly, licenceOnly, signatureOnly, onChange}) => {
  return (
    <Stack my={1} sx={{alignItems: 'center', justifyContent: 'center', width: '100%'}}>
        <Stack direction="row" py={1} sx={{alignItems: 'center', justifyContent: 'space-between', width: '100%', overflow: 'hidden'}}>
          <Typography className="label" variant="h4">{name}</Typography>
          <TextField
            value={trial ? trial : ''}
            id='trial'
            size='small'
            label='Триальный период, дней'
            placeholder='Запрещён'
            inputProps={{
              isAllowed: ({floatValue}) => (floatValue <= 365 && floatValue >= 0)
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccessTime />
                </InputAdornment>
              ),
              inputComponent: NumberField,
              endAdornment: <InputAdornment position="end">
                              <Stack>
                                <IconButton sx={{padding: '1px'}} disabled={trial>=365} onClick={() => onChange({trial: ++trial})}>
                                  <FontAwesomeIcon fontSize={'0.9rem'} icon={faCaretUp} />
                                </IconButton>
                                <IconButton sx={{padding: '1px'}} disabled={trial<=0} onClick={() => onChange({trial: --trial})}>
                                  <FontAwesomeIcon fontSize={'0.9rem'}icon={faCaretDown} />
                                </IconButton>
                              </Stack>
                            </InputAdornment>

            }}
            onChange={(value) => onChange({trial: value ? value : 0})}
            sx={{minWidth: 200, width: 200}}
          />                         
        </Stack>
        <Stack direction="row" sx={{alignItems: 'center', justifyContent: 'space-between', width: '100%', overflow: 'hidden'}}>
          <Typography className="label">Приложение работает только в составе профиля</Typography>
          <Switch
            checked={profileOnly}
            onChange={(e) => onChange({profileOnly: e.target.checked})}
          />                            
        </Stack>
        <Stack direction="row" sx={{alignItems: 'center', justifyContent: 'space-between', width: '100%', overflow: 'hidden'}}>
          <Typography className="label">Для работы приложения требуется лицензия</Typography>
          <Switch
            checked={licenceOnly}
            onChange={(e) => onChange({licenceOnly: e.target.checked})}
          />                            
        </Stack>
        <Stack direction="row" sx={{alignItems: 'center', justifyContent: 'space-between', width: '100%', overflow: 'hidden'}}>
          <Typography className="label">Выгружается на кассу с подписью Рестарт</Typography>
          <Switch
            checked={signatureOnly}
            onChange={(e) => onChange({signatureOnly: e.target.checked})}
          />                            
        </Stack>
    </Stack>
  );
};

export default AppOptions;